var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"button",class:_vm.classCss,style:(`background-color:${_vm.getColor}; border: 1px ${_vm.getColor} solid;`),on:{"click":_vm.handlerButton}},[_c('div',{},[_vm._t("default"),(_vm.loading)?_c('Spinner'):_c('div',[_c('p',[_vm._v(_vm._s(_vm.text.toUpperCase()))])])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }